import { Component, forwardRef, Injector, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, Validator } from '@angular/forms';
import { CustomFormControl } from '../custom-form-control.component';
import { NetzTranslateService } from 'src/app/services/netz-translate.service';

@Component({
  selector: 'app-drop-down',
  templateUrl: './drop-down.component.html',
  styleUrls: ['./drop-down.component.scss', '../../styles/custom-control.styles.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DropDownComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => DropDownComponent),
      multi: true,
    },
  ],
})
export class DropDownComponent extends CustomFormControl implements OnInit, ControlValueAccessor, Validator {
  @Input() options: { label: string; value: any }[] = [];
  @Input() placeholder: string;
  @Input() label: string;
  @Input() forceDisable: boolean;

  defaultPlaceholder: string = this.translationService.translateString('dropdown-placeholder');

  constructor(private translationService: NetzTranslateService, inj: Injector) {
    super(inj);
    this.preventLeak(translationService.registerForLanguageChange()).subscribe(() => {
      this.defaultPlaceholder = this.translationService.translateString('dropdown-placeholder');
    });
  }

  ngOnInit(): void {
    this.initBase();
  }

  selectedValue: any = null;

  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: any): void {
    this.selectedValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.applyDisabledState(isDisabled);
  }

  selectValue(value: any): void {
    this.selectedValue = value?.value;
    this.onChange(this.selectedValue); // Notify Angular Forms
    this.onTouched(); // Mark as touched
  }

  registerOnValidatorChange?(fn: () => void): void {}
}
